/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { STATUS_CREATED, STATUS_DATA_COMPLETED, STATUS_WAITING_FOR_FEEDBACK } from "@/src/services/litigationCase/leadStatus";
import { APPLICATION_STATUS_SUMMARY } from "./applicationStatus";
import React from "react";
import { getCaseLink, getProductData } from "@/src/services/productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { getButton, getContent, getPercentage } from "@/src/services/litigationCase/statusBoxSteps";
import { ExtraContent } from "@/src/services/litigationCase/StatusBox/ExtraContent";

const getContentContractLaw = (contractLawCase: AbstractCase) => {
  switch (contractLawCase.caseCategory) {
    case "advisory":
      return getContent(contractLawCase);
    default:
      switch (contractLawCase.leadStatus) {
        case STATUS_CREATED:
          if (contractLawCase.applicationStatus <= APPLICATION_STATUS_SUMMARY && contractLawCase.name === "dataLeakContract") {
            return {
              header: "Kurz Fall schildern und prüfen lassen",
              text: contractLawCase.powerOfAttorney
                ? "Bitte ergänzen Sie kurz Angaben zu Ihrem Mobilfunkvertrag und Ihrer Versicherung, damit wir Schadensersatz für Sie erwirken können."
                : "Sie machen Angaben zu Ihrem Mobilfunk-Vertrag und erteilen uns die Vollmacht, damit wir Schadensersatz für Sie erwirken können.",
              buttonLabel: "Jetzt Fall schildern",
              buttonTarget: getCaseLink(contractLawCase) + "/antrag",
            };
          }
          return getContent(contractLawCase);
        case STATUS_DATA_COMPLETED:
        case STATUS_WAITING_FOR_FEEDBACK:
          if (contractLawCase.name === "dataLeakContract") {
            return {
              header: "Ihre Angaben sind vollständig",
              text:
                "Wenn die Datenkopie vorliegt, prüfen wir zunächst Ihren Anspruch und werden dann die Kostendeckung" +
                " mit der Rechtsschutzversicherung klären und uns an den Mobilfunkanbieter wenden, um Schadensersatz für" +
                " Sie zu erwirken. Ihrerseits ist nichts weiter zu tun, außer etwas Geduld zu haben. Denn das Vorgehen " +
                "dauert erfahrungsgemäß mehrere Monate. Wichtig: Es besteht für Sie zu keiner Zeit ein Kostenrisiko! " +
                "Sollte die Versicherung Ihr Anliegen nicht decken wollen, versuchen wir alles, um doch eine Deckung zu " +
                "erwirken. Wenn die Deckung schlussendlich trotzdem verwehrt werden sollte, wird der Fall unserseits " +
                "abgeschlossen und es kommen keine Kosten auf Sie zu!",
            };
          }
          return getContent(contractLawCase);
        default:
          return getContent(contractLawCase);
      }
  }
};

export const getStatusBoxConfigContractLawCase = (contractLawCase: AbstractCase) => {
  const content = getContentContractLaw(contractLawCase);
  return {
    header: content.header,
    text: content.text,
    ctaButton: getButton(contractLawCase),
    productName: getProductData(contractLawCase.name, "label"),
    percentage: getPercentage(contractLawCase),
    extraContent: <ExtraContent litigationCase={contractLawCase} />,
  };
};
